export const Quota = import(/* webpackChunkName: "Quota" */"./Quota");
